import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Carousel from "components/carousel"
import TestimonialCard from "./TestimonialCard"

const TestimonialWrap = ({
  className = "",
  sliderWrapperClassname = "p-10",
}) => {
  const data = useStaticQuery(graphql`
    query {
      allWpTestimonial(limit: 6) {
        nodes {
          content
          testimonial {
            testimonialAuthor
          }
          title
        }
      }
    }
  `)

  const testimonials = data.allWpTestimonial.nodes

  return (
    <div className={`card shadow-lg ${className}`}>
      <div className="row gx-0">
        <div
          style={{
            backgroundImage: "url(/img/testimonial.jpg)",
          }}
          className="col-lg-6 image-wrapper bg-image bg-cover rounded-top rounded-lg-start"
        />
        <div className="col-lg-6">
          <div className={sliderWrapperClassname}>
            <div className="swiper-container dots-closer mb-4">
              <Carousel grabCursor slidesPerView={1} navigation={false}>
                {testimonials.map((testimonial, i) => (
                  <TestimonialCard key={i} {...testimonial} />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialWrap
